const SectionTitle = ({ children, ...props }: SectionTitleProps) => {
  return (
    <h6
      {...props}
      className={`${
        props?.className || ""
      } font-title font-bold text-content text-opacity-75 text-xl text-center`}
    >
      {children}
    </h6>
  );
};

interface SectionTitleProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  children?: string | JSX.Element;
}

export default SectionTitle;
